import { getEditCanvasBridge } from './editCanvasBridge';
import { useLocalizationStore } from './localizationStore';

/**
 * Opens the in-canvas translate flow for an image node.
 *
 * The chat is not collapsed here: `EditCanvas` hides the sidebar and its toggle for as long as
 * translate is active, so touching `useChatSidebarStore` would only outlive the flow — that store
 * is persisted, and every exit that isn't a successful generate would leave the chat collapsed.
 */
export const openLocalizationForImageNode = (nodeId: string): void => {
  // An image transform left running on this node (edit text, crop) would keep drawing its own
  // overlays underneath the translate UI.
  getEditCanvasBridge().resetCanvasMode();
  useLocalizationStore.getState().open(nodeId);
};
